export const multipleChangingPrio = async (sectionPrio: string[], allSectionWiseDetails: any) => {
  try {
    const allSectionName = allSectionWiseDetails.allSectionName
    const allSectionTotals = allSectionWiseDetails.allSectionTotals
    const allSectionObtained = allSectionWiseDetails.allSectionObtained
    const allSectionPercentages = allSectionWiseDetails.allSectionPercentages ? allSectionWiseDetails.allSectionPercentages : []

    const prioSection: any = {
      sectionName: [],
      total: [],
      obtained: [],
      percentage: [],
    }
    const nonPrioSection: any = {
      sectionName: [],
      total: [],
      obtained: [],
      percentage: [],
    }
    await sectionPrio.forEach((section: string) => {
      const itemIndex = allSectionName.findIndex((item: string) => item === section)
      if (itemIndex !== -1) {
        prioSection.sectionName.push(allSectionName[itemIndex])
        prioSection.total.push(allSectionTotals[itemIndex])
        prioSection.obtained.push(allSectionObtained[itemIndex])
        if (allSectionPercentages.length >= 1) {
          prioSection.percentage.push(allSectionPercentages[itemIndex])
        }
      }
    })

    //Checking other items also
    await allSectionName.forEach((item: string, index: number) => {
      if (!prioSection?.sectionName.includes(item)) {
        nonPrioSection.sectionName.push(item)
        nonPrioSection.total.push(allSectionTotals[index])
        nonPrioSection.obtained.push(allSectionObtained[index])
        if (allSectionPercentages.length >= 1) {
          nonPrioSection.percentage.push(allSectionPercentages[index])
        }
      }
    })
    const newSectionOrder = prioSection.sectionName.concat(nonPrioSection.sectionName) ?? []
    const newSectionTotal = prioSection.total.concat(nonPrioSection.total) ?? []
    const newSectionObtained = prioSection.obtained.concat(nonPrioSection.obtained) ?? []
    const newSectionPercentage = allSectionPercentages.length >= 1 ? prioSection.percentage.concat(nonPrioSection.percentage) : []
    return { newSectionOrder, newSectionTotal, newSectionObtained, newSectionPercentage }
  } catch (err) {
    console.log(err)
    return false
  }
}
